import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const ContentContext = createContext({ content: {}, t: (_k, f) => f, refresh: () => {} });
export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});

  const load = () =>
    api.get("/content").then(({ data }) => setContent(data)).catch(() => {});

  useEffect(() => { load(); }, []);

  const t = (key, fallback = "") =>
    content[key] != null && content[key] !== "" ? content[key] : fallback;

  return (
    <ContentContext.Provider value={{ content, t, refresh: load }}>
      {children}
    </ContentContext.Provider>
  );
}
